import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import { useSubFormIsValidSync } from '@hooks/use-sub-form-is-valid-sync';
import { PasswordTooltip } from '@web/components';
import { Cell, Grid, Input } from '@web/atoms';
import { useReporter } from '../../reporter';
import { schema } from './schema';
import { accountInformationCompleted } from './events';

export { schema } from './schema';

export const AccountInfoForm = ({
  labelEmail,
  labelPassword,
  labelConfirmation,
}) => {
  const { control } = useFormContext();
  const reporter = useReporter();
  const isValidForm = useSubFormIsValidSync(schema);

  useEffect(() => {
    if (isValidForm) {
      reporter.tag(accountInformationCompleted());
    }
  }, [isValidForm, reporter]);

  return (
    <Grid gap={{ row: 4, column: 2 }} columns={{ laptop: 1, mobile: 1 }}>
      <Cell>
        <Controller
          control={control}
          name="email"
          render={({ field, fieldState }) => (
            <Input
              {...field}
              labelText={labelEmail}
              status={fieldState.error ? 'error' : null}
              error={fieldState.error?.message || ''}
              autocomplete="email"
              disabled
            />
          )}
        />
      </Cell>
      <Cell>
        <Controller
          control={control}
          name="new_password"
          render={({ field, fieldState }) => (
            <Input
              {...field}
              status={fieldState.error ? 'error' : null}
              error={fieldState.error?.message || ''}
              type="password"
              labelText={labelPassword}
              icon={<PasswordTooltip />}
              autocomplete="new-password"
            />
          )}
        />
      </Cell>
      <Cell>
        <Controller
          control={control}
          name="confirm_password"
          render={({ field, fieldState }) => (
            <Input
              {...field}
              status={fieldState.error ? 'error' : null}
              error={fieldState.error?.message || ''}
              type="password"
              labelText={labelConfirmation}
              autocomplete="new-password"
            />
          )}
        />
      </Cell>
    </Grid>
  );
};

AccountInfoForm.displayName = 'AccountInfoForm';
AccountInfoForm.propTypes = {
  labelEmail: PropTypes.string.isRequired,
  labelPassword: PropTypes.string.isRequired,
  labelConfirmation: PropTypes.string.isRequired,
};
